import React from 'react';

export default function CutsHeader({ searchTerm, setSearchTerm, children }) {
  return (
    <section className="section cuts-hero">
      <div className="container">
        <div className="cuts-hero__intro">
          <span className="cuts-hero__eyebrow">Beef Cuts</span>
          <h1 className="cuts-hero__title">A Guide to Beef Cuts</h1>
        </div>

        <div className="cuts-hero__layout">
          <div className="cuts-hero__card cuts-hero__explore">
            <h3 className="cuts-hero__card-title">
              Explore by Primal{' '}
              <span
                className="cuts-hero__card-arrow"
                aria-hidden="true"
              ></span>
            </h3>
            <p>Select a primal cut to explore the cuts within it.</p>
          </div>
          <div className="cuts-hero__graphic">{children}</div>
          <div className="cuts-hero__card cuts-hero__find">
            <h3 className="cuts-hero__card-title">Find a Cut</h3>
            <p>Search by cut name.</p>
            <div className="cuts-hero__search-row">
              <form
                className="cuts-hero__search"
                role="search"
                onSubmit={(e) => e.preventDefault()}
              >
                <input
                  type="text"
                  className="cuts-hero__search-input"
                  placeholder="Ribeye, Brisket, Flank..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  aria-label="Search cuts by name"
                />
                <button
                  type="submit"
                  className="cuts-hero__search-btn"
                  aria-label="Search"
                >
                  <span
                    className="cuts-hero__search-icon"
                    aria-hidden="true"
                  ></span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
